import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Panel, Action } from '@studiometa/ui';
import VariantSelects from './molecules/VariantSelects.js';
import VariantRadios from './molecules/VariantRadios.js';
import PickupAvailability from './molecules/PickupAvailability.js';
import PickupAvailabilityDrawer from './molecules/PickupAvailabilityDrawer.js';
import TopBar from './molecules/TopBar.js';
import Newsletter from './molecules/Newsletter.js';
import Store from './organisms/Store.js';
import Slider from './molecules/Slider/index.js';
import FooterList from './molecules/FooterList.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Panel,
      Action,
      Newsletter,
      Store,
      FooterList,
      'variant-selects': VariantSelects,
      'variant-radios': VariantRadios,
      'pickup-availability': PickupAvailability,
      'pickup-availability-drawer': PickupAvailabilityDrawer,
      TopBar,
      ListingMap: (app) =>
        importWhenVisible(() => import('./organisms/ListingMap/index.js'), 'ListingMap', app),
      Readmore: (app) => importWhenVisible(() => import('./atoms/Readmore.js'), 'Readmore', app),
      Video: (app) => importWhenVisible(() => import('./atoms/Video.js'), 'Video', app),
      Slider,
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion/index.js'), 'Accordion', app),
    },
  };

  /**
   * Listening from variantsSelects.js
   * @param  {string} currentVariantID
   * @param  {boolean} curentVariantAvailable
   * @returns {void}
   */
  onVariantRadiosUpdateAvailability(currentVariantID, curentVariantAvailable) {
    if (!this.$children['pickup-availability'][0]) return;

    if (currentVariantID && curentVariantAvailable) {
      // this.$children['pickup-availability'][0].fetchAvailability(currentVariantID);
    } else {
      this.$children['pickup-availability'][0].$el.removeAttribute('available');
      this.$children['pickup-availability'][0].$el.innerHTML = '';
    }
  }
}

export default createApp(App, document.body);
